import { useState } from "react";

import { Box, Card, CardActionArea, CardMedia, Container, Typography } from "@mui/material";

import CloudflowNavatticPreview from "../../assets/cloudflow/cf-navattic-preview.png";
import { NavatticDialog } from "./Dialog/NavatticDialog";

const NavatticSection = () => {
  const [openNavatticDialog, setOpenNavatticDialog] = useState(false);

  return (
    <>
      <Container maxWidth="lg" sx={{ pb: 2, pt: 4 }}>
        <Box sx={{ py: 2 }}>
          <Typography variant="h2" textAlign="center">
            Experience CloudFlow in action
          </Typography>
          <Typography variant="body1" textAlign="center" color="text.secondary">
            Take a self-guided tour to explore how CloudFlow can help you automate workflows, identify risk and take
            action.
          </Typography>
          <Card sx={{ maxWidth: "100%", mt: 2 }}>
            <CardActionArea
              onClick={() => {
                setOpenNavatticDialog(true);
              }}
              data-cy="cloudflow-tour-card"
            >
              <CardMedia component="img" image={CloudflowNavatticPreview} alt="CloudFlow Navattic Preview" />
            </CardActionArea>
          </Card>
        </Box>
      </Container>

      <NavatticDialog
        open={openNavatticDialog}
        onClose={() => {
          setOpenNavatticDialog(false);
        }}
      />
    </>
  );
};

export default NavatticSection;
